"use strict";
// @ts-ignore
try {
    self['workbox:background-sync:7.2.0'] && _();
}
catch (e) { }
